export const SPARE_PART_TYPE = {
  INSTALLED: `installed`,
  DEFECTIVE: `defective`,
}
